var O = typeof window > "u" || "Deno" in globalThis;
function m() {
}
function k(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function q(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function F(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function b(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function w(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function K(e, t) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: i,
    predicate: f,
    queryKey: o,
    stale: s
  } = e;
  if (o) {
    if (n) {
      if (t.queryHash !== j(o, t.options))
        return !1;
    } else if (!p(t.queryKey, o))
      return !1;
  }
  if (r !== "all") {
    const c = t.isActive();
    if (r === "active" && !c || r === "inactive" && c)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || i && i !== t.state.fetchStatus || f && !f(t));
}
function P(e, t) {
  const { exact: r, status: n, predicate: i, mutationKey: f } = e;
  if (f) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (a(t.options.mutationKey) !== a(f))
        return !1;
    } else if (!p(t.options.mutationKey, f))
      return !1;
  }
  return !(n && t.state.status !== n || i && !i(t));
}
function j(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || a)(e);
}
function a(e) {
  return JSON.stringify(
    e,
    (t, r) => h(r) ? Object.keys(r).sort().reduce((n, i) => (n[i] = r[i], n), {}) : r
  );
}
function p(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((r) => !p(e[r], t[r])) : !1;
}
function y(e, t) {
  if (e === t)
    return e;
  const r = d(e) && d(t);
  if (r || h(e) && h(t)) {
    const n = r ? e : Object.keys(e), i = n.length, f = r ? t : Object.keys(t), o = f.length, s = r ? [] : {};
    let c = 0;
    for (let l = 0; l < o; l++) {
      const u = r ? l : f[l];
      (!r && n.includes(u) || r) && e[u] === void 0 && t[u] === void 0 ? (s[u] = void 0, c++) : (s[u] = y(e[u], t[u]), s[u] === e[u] && e[u] !== void 0 && c++);
    }
    return i === o && c === i ? e : s;
  }
  return t;
}
function E(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function d(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function h(e) {
  if (!g(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const r = t.prototype;
  return !(!g(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function g(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function T(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function N(e, t, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(e, t);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return y(e, t);
      } catch (n) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${n}`
        );
      }
    return y(e, t);
  }
  return t;
}
function A(e, t, r = 0) {
  const n = [...e, t];
  return r && n.length > r ? n.slice(1) : n;
}
function I(e, t, r = 0) {
  const n = [t, ...e];
  return r && n.length > r ? n.slice(0, -1) : n;
}
var S = Symbol();
function H(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === S && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === S ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
export {
  A as addToEnd,
  I as addToStart,
  H as ensureQueryFn,
  k as functionalUpdate,
  a as hashKey,
  j as hashQueryKeyByOptions,
  d as isPlainArray,
  h as isPlainObject,
  O as isServer,
  q as isValidTimeout,
  P as matchMutation,
  K as matchQuery,
  m as noop,
  p as partialMatchKey,
  N as replaceData,
  y as replaceEqualDeep,
  w as resolveEnabled,
  b as resolveStaleTime,
  E as shallowEqualObjects,
  S as skipToken,
  T as sleep,
  F as timeUntilStale
};
